import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params} from '@angular/router';
import {filter} from 'rxjs/operators';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-patient-network-error',
  templateUrl: './patient-network-error.component.html',
  styleUrls: ['./patient-network-error.component.scss']
})
export class PatientNetworkErrorComponent implements OnInit {
  chatId: string;

  constructor(private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.route.params
      .pipe(
        filter((params) => params && params.id),
        untilDestroyed(this)
      )
      .subscribe((params: Params) => (this.chatId = params.id));
  }
}
